import "@/styles/footerStyle.less";
import React from "react";
import { footerContentList, copyRightItem } from "./footerData";

interface IfooterItemProps {
  type?: string,
  title: string | undefined;
  href?: string | undefined;
  className: string | undefined;
}

const FallbackFooter = (props: {footerData?: Array<IfooterItemProps>, from?: string}) => {
  const currentFooterData = props.footerData ? props.footerData : footerContentList;
  return (
    <footer className="footer">
      <nav className="navbar-footer navbar-fixed-bottom">
        <div className="container-fluid">
          <ul className="nav navbar-nav navbar-nav-footer">
            {currentFooterData.map((item, index) => {
              const { href = "", className = "", title } = item;
              return <li key={index}>
                {(props.from === "login" && index === 0) && <a aria-label={copyRightItem.title} style={{ color: "#616161", textDecoration: "none" }}>{copyRightItem.title}</a>}
                <a href={href} data-mscc-ic="'false'" target="_blank" rel="noreferrer" className={className} aria-label={title}>{title}</a>
                {(props.from !== "login" && index === currentFooterData.length - 1) && <a aria-label={copyRightItem.title} style={{ color: "#616161", textDecoration: "none" }}>{copyRightItem.title}</a>}
              </li>;
            })}
          </ul>
        </div>
      </nav>
    </footer>
  );
};

export default FallbackFooter;
